import { SearchEntity } from "PFApp/components/search_autocomplete/search_autocomplete.types";
import { SearchInput } from "PFApp/components/search_input";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";
import { useState } from "react";

import { RenderActionCell, RowSelection } from "../../resource_table_toggle";
import { NamedResourceTable } from "./named_resource_table";

type NamedResourcePanelProps = RowSelection & {
  pageKey: RecentSearchesPageKey;
  renderActionCell?: RenderActionCell;
};

export const NamedResourcePanel = ({
  onRowSelectionChange,
  rowSelectionState,
  pageKey,
  renderActionCell
}: NamedResourcePanelProps) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <>
      <SearchInput
        term={searchValue}
        pageKey={pageKey}
        onTermChange={(value: string) => setSearchValue(value)}
        autocompleteConfig={[{ entity: SearchEntity.Profile, useAsTerm: true, profileVisibility: "active" }]}
        fullWidth
      />
      <NamedResourceTable
        searchValue={searchValue}
        onRowSelectionChange={onRowSelectionChange}
        rowSelectionState={rowSelectionState}
        renderActionCell={renderActionCell}
      />
    </>
  );
};
